const generic_colors = {
    upper: "#d9534f",
    middle: "#31B452",
    lower: "#FFC83D",
}

export function get_colors(team_name){
    let colors = generic_colors;
    if (team_name == "Illinois Football"){
        colors = {...colors, lower: "#4cc9f0"}
    }
    return colors;
  }